type KioskDocumentKind = "pdf" | "external";

export const postKioskDocument = (
  kind: KioskDocumentKind,
  title: string,
  url: string,
  target: Window = window,
) => {
  const handler = kind === "pdf" ? target.pdfHandler : target.externalHandler;
  if (!handler) return false;
  handler.postMessage(JSON.stringify({ title, url }));
  return true;
};
